<script>
export default {
    name: 'pagination',
      props: {
        currentPage: Number,
        itemCount: Number,
        pageSize: Number,
        pagesToShow: String,
        showPageSize: Boolean,
    },
    data: function () {
        return {
            setIndex: 1,
            localPageSize: this.pageSize
        }
    },
    methods: {
        firstPage: function () {
            this.$emit('setPage', 1);
        },
        lastPage: function () {
            this.$emit('setPage', this.getPageCount);
        },
        nextPage: function () {
            var next = this.currentPage + 1;
            this.$emit('setPage', next);
        },
        previousPage: function () {
            var previous = this.currentPage - 1;
            this.$emit('setPage', previous);
        },
        setPageSize: function () {
            var pageSize = parseInt(this.localPageSize);
            this.$emit('setPageSize', pageSize);
        }
    },
    computed: {
        getPageCount: function () {
            return Math.ceil(this.itemCount / this.localPageSize);
        },
        visiblePageButtons: function () {
            var pagesToShow = parseInt(this.pagesToShow);
            this.setIndex = Math.ceil(this.currentPage / pagesToShow);
            var self = this;
            var highest = this.setIndex * pagesToShow;
            var lowest = highest - pagesToShow;

            var result = [];
            for (var i = lowest; i < highest; i++) {
                if ((i+1) <= self.getPageCount) {
                    result.push(i + 1);
                }
            }
            return result;
        }
    }
}
</script>
<template>
          <div style="text-align:center;position:relative;width:100%">
        <div class="pagination-wrapper">

            <button v-bind:disabled="currentPage == 1" type="button" class="btn" v-on:click="$emit('set-page', 1)">First</button>
            <button v-bind:disabled="setIndex == 1" v-on:click="$emit('set-page', ((setIndex-2)*parseInt(pagesToShow))+1)" type="button" class="btn">
                <i title="Back" class="fas fa-angle-double-left"></i>
            </button>
            <button v-bind:disabled="currentPage == 1" v-on:click="$emit('set-page', currentPage-1)" type="button" class="btn">
                <i title="Previous page" class="fas fa-angle-left"></i>
            </button>


            <span v-for="(page, index) in visiblePageButtons" v-on:click="$emit('set-page', page)" v-bind:class="[page == currentPage ? 'active-page page-number' : 'page-number']" :key="`pagination_${index}`">{{page}}</span>
            <button v-bind:disabled="currentPage == getPageCount" v-on:click="$emit('set-page', currentPage+1)" type="button" class="btn">
                <i title="Next page" class="fas fa-angle-right"></i>
            </button>

            <button v-bind:disabled="setIndex == Math.ceil(getPageCount / pagesToShow)" v-on:click="$emit('set-page', ((setIndex)*parseInt(pagesToShow)+1))" type="button" class="btn">
                <i title="Forward" class="fas fa-angle-double-right"></i>
            </button>
            <button v-bind:disabled="currentPage == getPageCount" type="button" class="btn" v-on:click="$emit('set-page', getPageCount)">Last</button>
        </div>
        <div v-if="showPageSize" class="page-count" style="float:right;display:inline-block;bottom:0px;right:0px;position:absolute">
            <label style="margin-right:0.5rem">Page Size</label>
            <select class="form-control" v-model="localPageSize" v-on:change="setPageSize" style="width:auto;display:inline">
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
            </select>
        </div>
    </div>
</template>

<style scoped>
    .pagination-wrapper .btn {
        padding:3px;
        margin: 2px;
    }
    .page-number{
        padding:6px;
        padding-left:10px;
        padding-right:10px;
        cursor:pointer;
        opacity:0.8;
    }
    .mobile > .pagination-wrapper > button , .mobile > .pagination-wrapper > .page-number {
        padding:10px;
        font-size:10px;
    }

    .btn {
        border-radius:2px;
        border: 1px solid #ced4da;
    }
    .active-page {
    font-weight:bold;
    opacity:1
    }
</style>

